import { takeEvery } from 'redux-saga/effects';

import { selectRange } from 'store/modules/listing/customPrices';

import * as customPrices from './utils';

export default function* listenSelectRange() {
  yield takeEvery(selectRange.toString(), customPrices.selectRange);
}
